const spacing = {
  base: '4px',
  lg: '8px'
};

const color = {
  black: '#191919', //프로젝트 들어가는 모든 검정색
  white: '#ffffff', // 프로젝트 들어가는 모든 하얀색
  primary: '#2D4FA6', // 버튼색상
  secondary: '#2E2F3F', // 장르 태그 플래그 색상
  inputcolor: '#3A3A3A',
  gray: '#292929',
  lightgray: '#363636',
  postback: '#232323'
};

const fontSize = {
  s: '1rem',
  md: '1.2rem',
  lg: '1.4rem',
  xl: '1.6rem',
  xxl: '1.8rem',
  xxxl: '2rem'
};

export const theme = {
  spacing,
  color,
  fontSize
};
